import { useContext, useEffect, useState } from 'react'
import { fetchSearchOptions } from '../helpers/fetchSearchOptions';
import { AppContext } from '../components/AppContext';

export const useFetchSearch = ( geoserverUrl, layerName, variableName ) => { 
    const { canton } = useContext(AppContext);
    const [searchOptions, setSearchOptions] = useState('');
    useEffect( () => {
        // if (layerName === 'limites_provinciales') {
        //         setLoadMapOption(false)
        //         setSearchOptions(provincia)        
        //     }
        // else 
        if (layerName === 'GyL_PorCanton_Emisiones_Percapita_2023') {
                setSearchOptions(canton)         
            }
        else {
        fetchSearchOptions( geoserverUrl, layerName, variableName )
            .then( data => {                
                setSearchOptions(data);
            })
        }
    }, [layerName])
    return searchOptions;
}